import { render, staticRenderFns } from "./itemBankDialog.vue?vue&type=template&id=455a28da&"
import script from "./itemBankDialog.vue?vue&type=script&lang=js&"
export * from "./itemBankDialog.vue?vue&type=script&lang=js&"
import style0 from "./itemBankDialog.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports